import React from 'react';
import { MegarubigramStore } from '../../MegarubigramStore';

type ControlSubgridProps = {
  gridId: number;
  subgridId: number;
};

const SolvedControlSubgrid = ({ gridId, subgridId, }: ControlSubgridProps) => {
  const grid = MegarubigramStore.useState(s => s.grids[gridId]);
  const subgrid = grid.subgrids[subgridId];

  const blankLetterStyles: React.CSSProperties = {
    backgroundColor: '#777676',
  };

  return (
    <div className={`controlSubgrid subgrid${subgridId}`}>
      <div className="controlSubgridFlipper">
        <div className="controlSubgridContents">
          {subgrid.solution.map((row, rowIndex) => (
            <div key={rowIndex} className="gridRow">
              {row.map((cell, cellIndex) => (
                <div key={cellIndex} className="gridCellContainer">
                  <div className="gridCell"
                    style={cell === '.' ? blankLetterStyles : {}}
                  >
                    {cell === '.' ? '' : cell}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default SolvedControlSubgrid;